import { Fragment, useState, useEffect } from 'react';
// rooutes
import { useHistory } from 'react-router-dom';
import routes from '../../../constants/routes';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { doChangePassword, doLogin } from '../../../redux/thunks/authentication';
import { selectModalState } from '../../../redux/selectors/showModal';

// style
import styles from '../styles.module.scss';

// Logo
import CompanyLogo from '../../../assets/images/logo.png';

// components
import LoginForm from './LoginForm';
import UILink from '../../../components/Buttons/UILink';
import Footer from '../../../components/Footer';
import NewPasswordForm from '../NewPassword/NewPasswordForm';
import { doHideModal } from '../../../redux/actionCreators/showModal';
import FlexRow from '../../../components/FlexBox/FlexRow';
import Typography from '../../../components/Typography/Typography';
import FlexColumn from '../../../components/FlexBox/FlexColumn';
import zIndex from '@material-ui/core/styles/zIndex';
import { doLoginSuccess } from '../../../redux/actionCreators/authentication';

const Login = () => {
  const [valuess, setValues] = useState(null);
  const [modal, setModal] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);

  // Retrieve the values of the query parameters

  const showModal = useSelector(selectModalState);

  const param1 = params.get('module');

  useEffect(() => {
    const res = async () => {
      if (showModal && valuess) {
        setModal(true);
      } else {
        setModal(false);
      }
    };

    res();
  }, [param1, modal, showModal, valuess]);

  const handleLoginAttempt = (values,) => {
    setValues(values);
    dispatch(doLogin(values, () => {
      setLoggedIn(true);
      setTimeout(() => {
        dispatch(doLoginSuccess());
        history.push(routes.dashboard.home);
      }, 1100);
    }));
  };

  const handlesubmit = async (values) => {
    setValues((prevValues) => {
      return { ...prevValues, ...values };
    });
    dispatch(doChangePassword(valuess, values));
  };

  const displayLeftSection = () => (
    <div className={styles['left_section']}>
      <div className={styles['login_image']}></div>
    </div>
  );

  const displayChangePasswordLeftSection = () => (
    <div className={styles['left_section']}>
      <div className={styles['login_image']}></div>
    </div>
  );

  const displayChangePasswordRightSection = () => (
    <FlexColumn justifyContent='flex-start' className={styles['right_section']}>
      <FlexRow alignItems='end'>
        <img style={{ width: '8rem' }} src={CompanyLogo} alt="Spintly" />
        <Typography variant={"h2M"}> | Partner</Typography>
      </FlexRow>
      <FlexColumn>
        <Typography variant={"b1M"} color='var(--info-700)'>Since this is your first time here we will need you to set a new password</Typography>
        <NewPasswordForm handleResetPassword={handlesubmit} />
        <Footer />
      </FlexColumn>
    </FlexColumn>
  );

  const displayRightSection = () => (
    <FlexColumn justifyContent='flex-start' flexWrap='nowrap' className={styles['right_section']}>
      <FlexRow alignItems='end'>
        <img style={{ width: '8rem' }} src={CompanyLogo} alt="Spintly" />
        <Typography variant={"h2M"}> | Partner</Typography>
      </FlexRow>
      <FlexColumn justifyContent='start' styles={{ height: '70dvh' }}>
        <FlexColumn>
          <Typography variant={"b1M"} color='var(--info-700)'>Welcome to Spintly Partner</Typography>
          <LoginForm handleLoginAttempt={handleLoginAttempt} />
        </FlexColumn>
        <Footer />
      </FlexColumn>
    </FlexColumn>
  );

  return (
    <FlexColumn styles={{ position: 'relative', overflow: 'hidden' }}>
      {!modal ? (
        <FlexColumn flexWrap='nowrap' className={`${styles['s-login-form']} ${styles[loggedIn ? 'hide-login-form' : '']}`} styles={{ height: '100dvh', zIndex: '1' }}>
          <FlexRow alignItems='end'>
            <img style={{ width: '8rem' }} src={CompanyLogo} alt="Spintly" />
            <Typography variant={"h2M"}> | Partner</Typography>
          </FlexRow>
          <FlexColumn justifyContent='start' styles={{ width: '30rem', maxWidth: '95%' }}>
            <FlexColumn>
              <Typography variant={"b1M"} color='var(--info-700)'>Welcome to Spintly Partner</Typography>
              <LoginForm handleLoginAttempt={handleLoginAttempt} />
            </FlexColumn>
            <Footer />
          </FlexColumn>
        </FlexColumn>
      ) : (
        <FlexColumn flexWrap='nowrap' styles={{ height: '100dvh', zIndex: '1' }}>
          <FlexRow alignItems='end'>
            <img style={{ width: '8rem' }} src={CompanyLogo} alt="Spintly" />
            <Typography variant={"h2M"}> | Partner</Typography>
          </FlexRow>
          <FlexColumn justifyContent='start' styles={{ width: '30rem', maxWidth: '95%' }}>
            <Typography variant={"b1M"} color='var(--info-700)'>Since this is your first time here we will need you to set a new password</Typography>
            <NewPasswordForm handleResetPassword={handlesubmit} />
            <Footer />
          </FlexColumn>
        </FlexColumn>
      )}
      <div className={`${styles['w-circle']} ${styles[loggedIn ? 'w-circle-anim' : '']}`} />

    </FlexColumn>
  );
};

export default Login;
